import BasicLayout from '@/layouts/basic-layout'

const prefix = 'owner-contract-payment-'
export default {
  path: '/financial-manage/owner-contract-payment',
  redirect: {name: `${prefix}index`},
  component: BasicLayout,
  children: [
    {
      path: 'index',
      name: `${prefix}index`,
      meta: {title: '业主合同付款管理'},
      component: () => import('@/pages/financial-manage/owner-contract-payment/index')
    },
    {
      path: 'detail-create',
      name: `${prefix}create`,
      auth: ['hidden'],
      meta: {title: '业主合同付款申请新增'},
      component: () => import('@/pages/financial-manage/owner-contract-payment/detail-create')
    },
    {
      path: 'detail-edit/:id',
      name: `${prefix}edit`,
      auth: ['hidden'],
      meta: {title: '业主合同付款申请编辑'},
      component: () => import('@/pages/financial-manage/owner-contract-payment/detail-edit')
    },
    {
      path: 'detail-view/:id',
      name: `${prefix}view`,
      auth: ['hidden'],
      meta: {title: '业主合同收付款情况详情'},
      component: () => import('@/pages/financial-manage/owner-contract-payment/detail-view')
    }
  ]
}
